export default __webpack_public_path__ + "static/new-perspective-page-preview-section-bg-mob-df680942d33e08c49a5f96b6bf41daef.jpg";